export function getRegistrationNumber(isDisabled: boolean, registrationNumber: string) {
    return isDisabled ? `*${registrationNumber}` : registrationNumber;
}
